import React, { useState } from "react";
import moment from "moment";
import { Form, Col, Row } from "react-bootstrap";

import { Checkbox } from "@cdk-uip/react-checkbox";
import {
  aadharNumberPattern,
  alphaNumericWithSpecialCharacterPattern,
  alphabetWithSpacePattern,
  emailIDPattern,
  embeddedSpacesPattern,
  MARTIAL_TYPES,
  mobileNumberPattern,
  panNumberPattern,
  pfUANNumberPattern
} from "../../constants/constants";
import useValidation from "../../util/useValidation";

export const PersonalInfo = ({
  personalDetails,
  genders,
  maritalStatusList,
  setCandidatePersonalDetails
}) => {
  const { handleOnBlurValidation, errors } = useValidation();
  const handleOnChangePersonalDetails = ({ target: { name, value, type } }) => {
    if (embeddedSpacesPattern.test(value)) {
      const updatedValue = getUpdatedValue(type, value);
      setCandidatePersonalDetails(name, updatedValue);
    }
  };

  const getUpdatedValue = (type, value) => {
    if (type === "date") {
      const isValidDate = moment(value).isValid();
      return isValidDate ? moment(value).format("YYYY-MM-DD") : null;
    } else return value.trimStart();
  };

  const handleOnBlurInput = e => {
    handleOnBlurValidation(e);
  };
  return (
    <div className="container w-100 mx-auto  org-details">
      <Form.Group as={Row} className="mb-0" controlId="firstName">
        <Form.Label column sm={3}>
          Name*
        </Form.Label>
        <Col sm={3}>
          <Form.Control
            size="sm"
            required
            placeholder="First name*"
            type="text"
            name="firstName"
            value={personalDetails.firstName}
            pattern={alphabetWithSpacePattern}
            onChange={handleOnChangePersonalDetails}
            onBlur={handleOnBlurInput}
            isInvalid={errors.firstName}
          />

          {errors.firstName && (
            <Form.Control.Feedback type="invalid">
              {errors.firstName.type === "required" && "First Name is required"}
              {errors.firstName.type === "pattern" &&
                "Must contain only alphabets and space"}
            </Form.Control.Feedback>
          )}
        </Col>
        <Col sm={3}>
          <Form.Control
            size="sm"
            placeholder="Middle name"
            type="text"
            name="middleName"
            value={personalDetails.middleName}
            pattern={alphabetWithSpacePattern}
            onChange={handleOnChangePersonalDetails}
            onBlur={handleOnBlurInput}
            isInvalid={errors.middleName}
          />
          {errors.middleName && (
            <Form.Control.Feedback type="invalid">
              {errors.middleName.type === "pattern" &&
                "Must contain only alphabets and space"}
            </Form.Control.Feedback>
          )}
        </Col>
        <Col sm={3}>
          <Form.Control
            size="sm"
            placeholder="Last name*"
            type="text"
            name="lastName"
            required
            value={personalDetails.lastName}
            pattern={alphabetWithSpacePattern}
            onChange={handleOnChangePersonalDetails}
            onBlur={handleOnBlurInput}
            isInvalid={errors.lastName}
          />
          {errors.lastName && (
            <Form.Control.Feedback type="invalid">
              {errors.lastName.type === "required" && "Last Name is required"}
              {errors.lastName.type === "pattern" &&
                "Must contain only alphabets and space"}
            </Form.Control.Feedback>
          )}
        </Col>
      </Form.Group>
      <Col sm={10} className="names-declaration">
        <Checkbox
          required
          className="p-2 mb-1"
          checked={personalDetails.isNamesVerified}
          onChange={evt => {
            setCandidatePersonalDetails("isNamesVerified", evt.target.checked);
          }}
        />
        I have verified my First Name and Last Name.
      </Col>
      <Form.Group as={Row} controlId="fullNamenfatherName">
        <Form.Label column sm={3}>
          Full Name (As per Aadhar)*
        </Form.Label>
        <Col sm={3}>
          <Form.Control
            size="sm"
            className="text-left"
            placeholder="Full name"
            type="text"
            name="fullNameAdhaarCard"
            required
            value={personalDetails.fullNameAdhaarCard}
            pattern={alphabetWithSpacePattern}
            onChange={handleOnChangePersonalDetails}
            onBlur={handleOnBlurInput}
            isInvalid={errors.fullNameAdhaarCard}
          />
          {errors.fullNameAdhaarCard && (
            <Form.Control.Feedback type="invalid">
              {errors.fullNameAdhaarCard.type === "required" &&
                "Full Name is required"}
              {errors.fullNameAdhaarCard.type === "pattern" &&
                "Must contain only alphabets and space"}
            </Form.Control.Feedback>
          )}
        </Col>
        <Form.Label column sm={3}>
          Father name*
        </Form.Label>
        <Col sm={3}>
          <Form.Control
            size="sm"
            placeholder="Father name"
            type="text"
            name="fatherName"
            required
            value={personalDetails.fatherName}
            pattern={alphabetWithSpacePattern}
            onChange={handleOnChangePersonalDetails}
            onBlur={handleOnBlurInput}
            isInvalid={errors.fatherName}
          />
          {errors.fatherName && (
            <Form.Control.Feedback type="invalid">
              {errors.fatherName.type === "required" &&
                "Father Name is required"}
              {errors.fatherName.type === "pattern" &&
                "Must contain only alphabets and space"}
            </Form.Control.Feedback>
          )}
        </Col>
      </Form.Group>

      <Form.Group as={Row} controlId="genderDOB">
        <Form.Label column sm={3}>
          Gender*
        </Form.Label>
        <Col sm={3}>
          <Form.Control
            size="sm"
            as="select"
            name="gender"
            required
            value={personalDetails.gender}
            onChange={handleOnChangePersonalDetails}
            onBlur={handleOnBlurInput}
            isInvalid={errors.gender}
          >
            <option value="">Choose...</option>
            {genders.length &&
              genders.map(gender => (
                <option value={gender.id}>{gender.genderType}</option>
              ))}
          </Form.Control>
          {errors.gender && (
            <Form.Control.Feedback type="invalid">
              {errors.gender.type === "required" && "Gender is required"}
            </Form.Control.Feedback>
          )}
        </Col>
        <Form.Label column sm={3} className="text-right">
          Birth Date*
        </Form.Label>
        <Col sm={3}>
          <Form.Control
            size="sm"
            type="date"
            required
            name="birthDate"
            value={moment(personalDetails.birthDate).format("YYYY-MM-DD")}
            onChange={handleOnChangePersonalDetails}
            placeholder="Birth Date"
            onBlur={handleOnBlurInput}
            isInvalid={errors.birthDate}
          />
          {errors.birthDate && (
            <Form.Control.Feedback type="invalid">
              {errors.birthDate.type === "required" && "Birth Date is required"}
            </Form.Control.Feedback>
          )}
        </Col>
      </Form.Group>
      <Form.Group as={Row} controlId="maitalStatusAnniversary">
        <Form.Label column sm={3}>
          Marital Status*
        </Form.Label>
        <Col sm={3}>
          <Form.Control
            size="sm"
            as="select"
            name="maritalStatus"
            required
            value={personalDetails.maritalStatus}
            onChange={handleOnChangePersonalDetails}
            onBlur={handleOnBlurInput}
            isInvalid={errors.maritalStatus}
          >
            <option value="">Choose...</option>
            {maritalStatusList.length &&
              maritalStatusList.map(maritalStatus => (
                <option value={maritalStatus.id}>
                  {maritalStatus.marital}
                </option>
              ))}
          </Form.Control>
          {errors.maritalStatus && (
            <Form.Control.Feedback type="invalid">
              {errors.maritalStatus.type === "required" &&
                "Marital Status is required"}
            </Form.Control.Feedback>
          )}
        </Col>

        <Form.Label column sm={3} className="text-right">
          Anniversay Date
        </Form.Label>
        <Col sm={3}>
          <Form.Control
            size="sm"
            type="date"
            disabled={+personalDetails.maritalStatus === MARTIAL_TYPES.SINGLE}
            placeholder="Anniversary Date"
            date-format="DD/MM/YYYY"
            name="anniversaryDate"
            value={moment(personalDetails.anniversaryDate).format("YYYY-MM-DD")}
            onChange={handleOnChangePersonalDetails}
          />
        </Col>
      </Form.Group>

      <Form.Group as={Row} controlId="mobileNumbers">
        <Form.Label column sm={3}>
          Mobile Number*
        </Form.Label>
        <Col sm={3}>
          <Form.Control
            size="sm"
            placeholder="Mobile Number"
            type="text"
            name="contactNumber"
            required
            value={personalDetails.contactNumber}
            pattern={mobileNumberPattern}
            onChange={handleOnChangePersonalDetails}
            onBlur={handleOnBlurInput}
            isInvalid={errors.contactNumber}
          />
          {errors.contactNumber && (
            <Form.Control.Feedback type="invalid">
              {errors.contactNumber.type === "required" &&
                "Mobile Number is required"}
              {errors.contactNumber.type === "pattern" &&
                "Please enter a valid Mobile Number"}
            </Form.Control.Feedback>
          )}
        </Col>

        <Form.Label column sm={3} className="text-right">
          Alternate Mobile Number*
        </Form.Label>
        <Col sm={3}>
          <Form.Control
            size="sm"
            placeholder="Alternate Mobile Number"
            type="text"
            name="alternateContactNo"
            required
            value={personalDetails.alternateContactNo}
            pattern={mobileNumberPattern}
            onChange={handleOnChangePersonalDetails}
            onBlur={handleOnBlurInput}
            isInvalid={errors.alternateContactNo}
          />
          {errors.alternateContactNo && (
            <Form.Control.Feedback type="invalid">
              {errors.alternateContactNo.type === "required" &&
                "Alternate Mobile Number is required"}
              {errors.alternateContactNo.type === "pattern" &&
                "Please enter a valid Mobile Number"}
            </Form.Control.Feedback>
          )}
        </Col>
      </Form.Group>

      <Form.Group as={Row} controlId="email">
        <Form.Label column sm={3}>
          Email*
        </Form.Label>
        <Col sm={3}>
          <Form.Control
            size="sm"
            placeholder="Email"
            type="text"
            name="emailId"
            required
            value={personalDetails.emailId}
            pattern={emailIDPattern}
            onChange={handleOnChangePersonalDetails}
            onBlur={handleOnBlurInput}
            isInvalid={errors.emailId}
          />
          {errors.emailId && (
            <Form.Control.Feedback type="invalid">
              {errors.emailId.type === "required" && "Email is required"}
              {errors.emailId.type === "pattern" &&
                "Please enter a valid Email ID"}
            </Form.Control.Feedback>
          )}
        </Col>

        <Form.Label column sm={3}>
          PAN Number*
        </Form.Label>
        <Col sm={3}>
          <Form.Control
            size="sm"
            placeholder="PAN Number"
            type="text"
            name="panCardNo"
            required
            value={personalDetails.panCardNo}
            pattern={panNumberPattern}
            onChange={handleOnChangePersonalDetails}
            onBlur={handleOnBlurInput}
            isInvalid={errors.panCardNo}
          />
          {errors.panCardNo && (
            <Form.Control.Feedback type="invalid">
              {errors.panCardNo.type === "required" && "PAN Number is required"}
              {errors.panCardNo.type === "pattern" &&
                "Please enter a valid PAN Number"}
            </Form.Control.Feedback>
          )}
        </Col>
      </Form.Group>

      <Form.Group as={Row} controlId="pFUANNumber">
        <Form.Label column sm={3} className="text-right">
          PF UAN Number
        </Form.Label>
        <Col sm={3}>
          <Form.Control
            size="sm"
            placeholder="PF UAN Number"
            type="text"
            name="pfUanNo"
            value={personalDetails.pfUanNo}
            pattern={pfUANNumberPattern}
            onChange={handleOnChangePersonalDetails}
            onBlur={handleOnBlurInput}
            isInvalid={errors.pfUanNo}
          />
          {errors.pfUanNo && (
            <Form.Control.Feedback type="invalid">
              {errors.pfUanNo.type === "pattern" &&
                "Please enter a valid PF UAN Number"}
            </Form.Control.Feedback>
          )}
        </Col>
        <Form.Label column sm={3} className="text-right">
          Aadhar Number*
        </Form.Label>
        <Col sm={3}>
          <Form.Control
            size="sm"
            placeholder="Aadhar Number"
            type="text"
            name="adhaarNumber"
            required
            value={personalDetails.adhaarNumber}
            pattern={aadharNumberPattern}
            onChange={handleOnChangePersonalDetails}
            onBlur={handleOnBlurInput}
            isInvalid={errors.adhaarNumber}
          />
          {errors.adhaarNumber && (
            <Form.Control.Feedback type="invalid">
              {errors.adhaarNumber.type === "required" &&
                "Aadhar Number is required"}
              {errors.adhaarNumber.type === "pattern" &&
                "Please enter a valid Aadhar Number"}
            </Form.Control.Feedback>
          )}
        </Col>
      </Form.Group>
      <Form.Group as={Row} controlId="emergencyContactHeader">
        <Form.Label column sm={3} className="emergency-details-heading">
          <h6> Emergency Contact Details</h6>
        </Form.Label>
      </Form.Group>
      <Form.Group as={Row} controlId="emergencyContact">
        <Form.Label column sm={3}>
          Person Name*
        </Form.Label>
        <Col sm={3}>
          <Form.Control
            size="sm"
            placeholder="Person Name"
            type="text"
            name="emergencyPersonName"
            required
            value={personalDetails.emergencyPersonName}
            pattern={alphabetWithSpacePattern}
            onChange={handleOnChangePersonalDetails}
            onBlur={handleOnBlurInput}
            isInvalid={errors.emergencyPersonName}
          />
          {errors.emergencyPersonName && (
            <Form.Control.Feedback type="invalid">
              {errors.emergencyPersonName.type === "required" &&
                "Person Name is required"}
              {errors.emergencyPersonName.type === "pattern" &&
                "Must contain only alphabets and space"}
            </Form.Control.Feedback>
          )}
        </Col>

        <Form.Label column sm={3}>
          Relationship*
        </Form.Label>
        <Col sm={3}>
          <Form.Control
            size="sm"
            placeholder="Relationship"
            type="text"
            name="relationWithMe"
            required
            value={personalDetails.relationWithMe}
            pattern={alphaNumericWithSpecialCharacterPattern}
            onChange={handleOnChangePersonalDetails}
            onBlur={handleOnBlurInput}
            isInvalid={errors.relationWithMe}
          />
          {errors.relationWithMe && (
            <Form.Control.Feedback type="invalid">
              {errors.relationWithMe.type === "required" &&
                "Relationship is required"}
              {errors.relationWithMe.type === "pattern" &&
                "Invalid characters entered for Relationship"}
            </Form.Control.Feedback>
          )}
        </Col>
      </Form.Group>
      <Form.Group as={Row} controlId="emergencyContact">
        <Form.Label column sm={3}>
          Mobile Number*
        </Form.Label>
        <Col sm={3}>
          <Form.Control
            size="sm"
            placeholder="Mobile Number"
            type="text"
            name="emergencyContactNo"
            required
            value={personalDetails.emergencyContactNo}
            pattern={mobileNumberPattern}
            onChange={handleOnChangePersonalDetails}
            onBlur={handleOnBlurInput}
            isInvalid={errors.emergencyContactNo}
          />
          {errors.emergencyContactNo && (
            <Form.Control.Feedback type="invalid">
              {errors.emergencyContactNo.type === "required" &&
                "Mobile Number is required"}
              {errors.emergencyContactNo.type === "pattern" &&
                "Please enter a valid Mobile Number"}
            </Form.Control.Feedback>
          )}
        </Col>
      </Form.Group>
    </div>
  );
};
export default PersonalInfo;
